import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ChooseSeriesItem } from './choose-series-item.interface';

@Component({
  selector: 'app-choose-series-modal',
  templateUrl: './choose-series-modal.component.html',
  styleUrls: ['./choose-series-modal.component.scss'],
})
export class ChooseSeriesModalComponent implements OnInit {
  @Output() onApprove = new EventEmitter();

  maxQuantity = 1;

  form = this.fb.group({
    series: [this.data.items[0], Validators.required],
    quantity: [1, Validators.required],
    boxNumber: [this.data.items[0].boxNumber, Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChooseSeriesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { approveText: string; items: ChooseSeriesItem[] },
  ) {}

  ngOnInit() {
    this.maxQuantity = this.data.items[0].quantity;
  }

  seriesChange(event: MatSelectChange) {
    this.maxQuantity = event.value.quantity;
    this.form.patchValue({
      quantity: 1,
      boxNumber: event.value.boxNumber,
    });
  }

  approve() {
    this.onApprove.next(this.form.value);
    this.dialogRef.close();
  }

  reject() {
    this.dialogRef.close();
  }
}
